import React from 'react'
import { useState } from 'react'
import StudiosBatches from "../studioBatches.json"


const MotorCityLocation = () => {
    const [toggleTab,setToggleTab] = useState(0)

    const [program,setProgram] = useState("Red")
    const handleToggle = (index,prog) => {
        setToggleTab(index)
        setProgram(prog)
    }

    

  return (
    <div className='BurCityLocation'>

        <div className="burcityLocationImg">
                <div className="locationNameResponsive">
                    <p>Motor City</p>
                    <div className="currentLocation">
                        <img src="/assets/locationMarker.svg" alt="" />
                        <span>Office no 411 , Detroit House</span>
                    </div>
                </div>
            <div className="locationImg">
                <img src="/assets/locations/motorCity.png" alt="" />
            </div>
            <div className="locationMap">
                <div className="locationName">
                    <p>Motor City</p>
                    <div className="currentLocation">
                        <img src="/assets/locationMarker.svg" alt="" />
                        <span>Office no 411 , Detroit House</span>
                    </div>
                </div>
                <div className="mapLocation">
                <iframe style={{border:"0px"}} src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d1807.3256401214926!2d55.229829!3d25.0459058!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5f6e71529988bd%3A0xcc8c58e2608821d1!2sBharat%20Thakur&#39;s%20Artistic%20Yoga%20-%20Motor%20City!5e0!3m2!1sen!2sin!4v1671287842063!5m2!1sen!2sin" width="100%" height="100%" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                </div>
            </div>
        </div>


        <div className="contactDetails d-flex justify-content-end" style={{marginTop:"10px"}}>
                <div className="callDetails">
                    <img src="/assets/callIcon.png" alt="" />
                    <a className='text-black' href='tel:971585759017'>
                <p>+971 5863 40992</p>
                </a>
                </div>

                <div className="callDetails" style={{marginLeft:"40px"}}>
                <a
                      rel='noreferrer'
                      target='_blank'
                      href={`https://wa.me/971585759017?text=Hi%20I%20am%20interested%20in%20joining%20the%20${program}%20program.%20Can%20you%20please%20share%20more%20details.%20Thanks%20`}
                      // {user!==null || undefined ? user?.firstName.split(" ")[0]:""}
                     >
                    <img src="assets/whatsappIcon.png" alt="" />
                    <p className='BookNow' style={{textDecoration:"underline"}}>Book Now</p>
                </a>
                </div>
            </div>

        <div className="divider"></div>

       <div className="TabsContainer">

        <div className='ClassTabContent'>
            <h2>Batch Timings</h2>
        </div>
        

        <div className='d-flex'>
             {/* ================RED Time======================== */}
                {toggleTab == 0 && 
                
                <div className="ClassTabContent d-flex align-items-start timing-container">

                    <div>
                        <h3 style={{marginBottom:"5px"}}>AM (Morning): Duration - 1 Hour</h3>
                    
                        <div className="normalTime flex-wrap">
                            {
                                StudiosBatches.MotorCity.map((item)=>(
                                    item.NormalBatch.map((value)=>(
                                        value?.batch == "morning" ?
                                        <span className={`batch-time ${item.id === "Red" ? "red-bg" : ""}`}>{value.time}</span> : <></>
                                    ))  
                                        
                                ))
                            }

                            {
                                StudiosBatches.MotorCity.map((item)=>(
                                    item.LadiesBatch && item.LadiesBatch.map((value)=>(
                                            value?.batch == "morning" ?
                                            <span className={`batch-time ${item.id === "Red" ? "red-bg" : ""}`}>{value.time}</span> : <></>
                                        ))        
                                    ))
                            }

                        </div>
                    </div>
                    

                    <div>
                        <h3 style={{marginBottom:"5px"}}>PM (Evening): Duration - 1 Hour</h3>
                        <div className="normalTime">
                            {
                                StudiosBatches.MotorCity.map((item)=>(
                                    item.NormalBatch && item.NormalBatch.map((value)=>(
                                        value?.batch == "evening" ?
                                        <span className={`batch-time ${item.id === "Red" ? "red-bg" : ""}`}>{value.time}</span> : <></>
                                    ))        
                                ))
                            }

                            { StudiosBatches.MotorCity.map((item)=>(
                                item?.LadiesBatch?.length > 0 && <div className="ladiesTime">
                                {
                                    StudiosBatches.MotorCity.map((item)=>(
                                        item.LadiesBatch && item.LadiesBatch.map((value)=>(
                                            value?.batch == "evening" ?
                                            <span className={`batch-time ${item.id === "Red" ? "red-bg" : ""}`}>{value.time}</span> : <></>
                                        ))        
                                    ))
                                }
                        </div>))}
                        
                        </div>
                    </div>
                </div>}
        </div>
        
        <div className='d-flex align-items-center'>
            <div className="differentiate ClassTabContent d-flex gap-1 align-items-center">
                <div className="ay-indicator"></div>
                <span style={{marginLeft:"3px",fontSize:"13px",fontWeight:"300"}}>AY Classic</span>
            </div>
             <div className="differentiate ClassTabContent d-flex gap-1 align-items-center">
                <div className="red-indicator"></div>
                <span style={{marginLeft:"3px",fontSize:"13px",fontWeight:"300"}}>Red</span>
            </div>
        </div>
       

        </div>

       
    </div>
  )
}

export default MotorCityLocation